export const LANGUAGES = [
  { label: "English", code: "en" },
  { label: "Arabic", code: "arsa" },
];
